module.exports = __webpack_public_path__ + "static/message-bg_left-0979c2e4afb3bb3de33744b716ce7c6e.png";